module.exports = __webpack_public_path__ + "static/media/Teams-arrow-right.85cea81a.svg";